import React from 'react';
import PropTypes from 'prop-types';

import Login from 'components/LandingPage/Login';

import logo from 'assets/img/logo.png';
import 'assets/scss/landingPage.css';

const LandingPageHeader = ({ showLogin }) => {
  const loginContainer = showLogin ? <Login /> : null;

  return (
    <header className="header inner-header">
      <div className="navbar navbar-dark">
        <div className="container d-flex justify-content-between">
          <a href="/" className="navbar-brand d-flex align-items-center">
            <img src={logo} title="Soono Logo" alt="Soono Logo" />
          </a>
          {loginContainer}
        </div>
      </div>
    </header>
  );
};

LandingPageHeader.propTypes = {
  showLogin: PropTypes.bool.isRequired,
};

export default LandingPageHeader;



// WEBPACK FOOTER //
// ./src/components/LandingPage/Header.jsx